export default function ErrorMessage({ error }) {
  if (!error) return null

  // Jika array
  if (Array.isArray(error)) {
    return (
      <>
        {error.map((msg, index) => (
          <div key={index} className="mt-1 text-[11px] text-red-600">
            {msg}
          </div>
        ))}
      </>
    )
  }

  // Jika object (Laravel validation biasanya begini)
  if (typeof error === "object") {
    return (
      <>
        {Object.values(error).map((msg, index) => (
          <div key={index} className="mt-1 text-[11px] text-red-600">
            {msg}
          </div>
        ))}
      </>
    )
  }

  // Default string
  return (
    <div className="mt-1 text-[11px] text-red-600">
      {error}
    </div>
  )
}